import { Injectable, Injector } from '@angular/core';
import { SynchronizationServiceBase } from './synchronization-service-base';
import { SynchronizationEntity } from './synchronization-entity';
import { HarvestActivityReportRepository } from '../local-db/repositories/harvest-activity-report-repository';

@Injectable({ providedIn: 'root' })
export class HarvestActivityReportSyncService extends SynchronizationServiceBase {
  constructor(
    injector: Injector,
    private readonly _harvestActivityReportRepo: HarvestActivityReportRepository
  ) {
    super(injector, SynchronizationEntity.HarvestActivityReports);
  }

  public async synchronize(): Promise<void> {
    await this._harvestActivityReportRepo.refreshHarvestActivityReport();
  }
}
